import { Avatar, Collapse, ConfigProvider, Descriptions, Tag, Typography } from 'antd'
import type { CollapseProps } from 'antd'

import type { PreviousTreatment } from './previous-treatments.types'

const { Text } = Typography

const TINTS: ReadonlyArray<readonly [string, string]> = [
  ['#eef2ff', '#4f56d1'],
  ['#ecfdf5', '#0e9f6e'],
  ['#fff1f0', '#cf1322'],
  ['#fff7e6', '#d46b08'],
]

interface Props {
  treatments: PreviousTreatment[]
}

export const PreviousTreatments = ({ treatments }: Props) => {
  if (!treatments.length) {
    return null
  }

  const innerItems: CollapseProps['items'] = treatments.map((treatment, index) => {
    const [background, color] = TINTS[index % TINTS.length]
    const { fields } = treatment

    const label = (
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
        <Avatar shape='square' style={{ background, color, fontWeight: 700, flex: 'none' }}>
          {(treatment.procedure || '?').charAt(0).toUpperCase()}
        </Avatar>
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3, minWidth: 0 }}>
          <span style={{ fontWeight: 600, color: '#111827' }}>{treatment.procedure}</span>
          <Text type='secondary' style={{ fontSize: 12 }}>
            {treatment.date}
          </Text>
        </div>
        <div style={{ marginLeft: 'auto', flex: 'none' }}>
          <Tag bordered={false}>{fields.length} values</Tag>
        </div>
      </div>
    )

    const body = (
      <Descriptions
        bordered
        size='small'
        column={{ xs: 1, sm: 2, md: 3 }}
        items={fields.map((field) => ({
          key: field.name,
          label: field.label,
          children: field.value,
        }))}
      />
    )

    return { key: treatment.id, label, children: body }
  })

  const outerLabel = (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontWeight: 600 }}>
      Extra Data
      <Tag bordered={false} style={{ margin: 0 }}>
        {treatments.length}
      </Tag>
    </span>
  )

  return (
    <ConfigProvider theme={{ token: { borderRadius: 8 } }}>
      <Collapse
        expandIconPosition='end'
        items={[
          {
            key: 'pt',
            label: outerLabel,
            children: (
              <Collapse
                expandIconPosition='end'
                items={innerItems}
                style={{ background: '#fff' }}
              />
            ),
          },
        ]}
      />
    </ConfigProvider>
  )
}
